import React from 'react'

const Wave = () => (
    <svg width="2618" height="363" viewBox="0 0 2618 363" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2617.49 362.101H0.420839H0.417969C27.1028 341.641 96.5147 250.29 314.429 203.761C564.392 150.387 834.794 135.265 1096.35 135.265C1373 135.265 1835.57 136.155 2196.73 102.352C2485.66 75.3091 2597.62 23.4777 2617.49 0.942383V362.101Z" fill="currentColor"/>
    </svg>
)

export default Wave
